module.exports = __webpack_public_path__ + "static/media/github.6b4b0b35.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/github.png
// module id = 102
// module chunks = 0